import React, { useRef, useState } from 'react';

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

import JurisdictionChooser from './JurisdictionChooser';
import PostCodeInput from '../../../app/common/ui/locations/PostCodeInput';

const sizes = {
    xs: 12, md: 6, lg: 3
}

const GridItem = ({ children }) => {
    return <Grid item {...sizes} style={{ marginTop: '0.5rem' }} >
        {children}
    </Grid>;
}



const CreateReferralContent = ({ referrer, organization, onSubmit }) => {

    const [jurisdiction, setJurisdiction] = useState('tier1');
    const [location, setLocation] = useState();
    const [name, setName] = useState('vulnerable person');

    const nameRef = useRef();
    const ageRef = useRef();
    const notesRef = useRef();
    const caseNumberRef = useRef();
    const datesRef = useRef();

    const handlePostCodeChange = place => {
        setLocation({
            geo: {
                longitude: place.longitude,
                latitude: place.latitude
            },
            postcode: place.postcode,
            name: `${place.admin_ward}, ${place.admin_district}, ${place.region}`
        });
    }

    const handleSubmit = () => {
        const referral = {
            courtCase: {
                serviceUserName: nameRef.current?.value || '',
                courtCaseNumber: caseNumberRef.current?.value || '',
            },
            request: {
                tariff: jurisdiction,
                client: {
                    age: ageRef.current?.value || ''
                },
                clientNeeds: notesRef.current?.value || '',
                dates: datesRef.current?.value || '',
                message: notesRef.current?.value || '',
                location,
            }
        };

        console.log('handleSubmit', referral)
        onSubmit({ ...referral });
    }

    return (
        <div>
            <Typography variant="h6" color="initial">Create a referral for {referrer.name} at {organization.name}</Typography>
            <Grid container direction="column" spacing={1}>
                <GridItem>
                    <JurisdictionChooser onChange={setJurisdiction} />
                </GridItem>
                <GridItem>
                    <TextField
                        id="name"
                        label="Name"
                        helperText="The vulnerable person's name"
                        inputRef={nameRef}
                        onChange={() => setName(nameRef.current?.value || 'vulnerable person')}
                        fullWidth
                        required
                    />
                </GridItem>
                <GridItem>
                    <TextField
                        id="age"
                        label="Age"
                        helperText={`The ${name}'s age (if known)`}
                        inputRef={ageRef}
                        fullWidth
                        type="number"
                        inputProps={{
                            min: 0,
                            max: 118
                        }}
                    />
                </GridItem>
                <GridItem>
                    <TextField
                        inputRef={notesRef}
                        id="vpnotes"
                        label="Case Notes"
                        helperText={`Add any notes about ${name} or the case`}
                        fullWidth
                        multiline
                        rows={8}
                        variant="outlined"
                    />
                </GridItem>
                <GridItem>
                    <TextField
                        id="casenumber"
                        label="Case Number"
                        helperText="The court case number (if known)"
                        inputRef={caseNumberRef}
                        fullWidth
                        variant="standard"
                    />
                </GridItem>

                <GridItem>
                    <PostCodeInput
                        postcode=''
                        description=''
                        label='Service Location Postcode'
                        onChange={handlePostCodeChange}
                        textFieldVariant="standard"
                    />
                </GridItem>
                <GridItem>
                    <TextField
                        inputRef={datesRef}
                        id="datenotes"
                        label="Timescale Notes"
                        helperText={`Add any notes about timescales or dates`}
                        fullWidth
                        multiline
                        rows={8}
                        variant="outlined"
                    />
                </GridItem>

                <GridItem>
                    <Button
                        onClick={handleSubmit}
                        disabled={!Boolean(nameRef.current?.value)}
                        variant="contained"
                        color="secondary"
                        fullWidth>
                        Save referral and go to quote
                    </Button>
                </GridItem>
            </Grid>

        </div>
    );
};

export default CreateReferralContent;